import React from 'react'

interface DeleteGroupConfirmationModalProps {
    isOpen: boolean
    onConfirm: () => void
    onCancel: () => void
}

export default function DeleteGroupConfirmationModal({ isOpen, onConfirm, onCancel }: DeleteGroupConfirmationModalProps) {
    if (!isOpen) return null

    return (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Supprimer le paramétrage groupe</h5>
                        <button type="button" className="close" onClick={onCancel}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <p>
                            Êtes-vous sûr de vouloir supprimer le paramétrage de signature électronique pour le groupe ?
                        </p>
                        <p className="text-warning">
                            <i className="fa fa-info-circle mr-1"></i>
                            Si des signatures ont déjà été générées via ce paramétrage, celui-ci sera <strong>archivé</strong> afin de conserver l'historique.
                        </p>
                        <p className="text-danger">
                            <i className="fa fa-exclamation-triangle mr-1"></i>
                            Dans le cas contraire, tous les contrats, connexions, alertes et relances associés seront définitivement supprimés.
                        </p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onCancel}>
                            Annuler
                        </button>
                        <button type="button" className="btn btn-danger" onClick={onConfirm}>
                            Supprimer le paramétrage
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
